<template lang="pug">
.card.payment(:class="{'card--expand': isProgressState, 'card--done': isFinishedState}")
    .loader-content(v-if="isLoading" class="loader-content__payment z-999")
      cp-loader(text="Aguarde estamos processando")

    .msg-error(v-if="errorMsg" class="z-999")
      img.msg-error__icon(src='@/assets/icons/warning.svg')
      span {{ errorMsg }}

    .card__head
      .titleStep
        cp-icon.titleStep__icon(v-if="!hasMobile" :path="`/icons/card${!isFinishedState ? '-off' : ''}.svg`")
        h3.titleStep__title {{ titleStep }}

      .btnEdit(v-if="isFinishedState && !hasMobile" @click="openStep")
        img.btnEdit__icon(src='@/assets/icons/edit.svg')
        span.btnEdit__label Editar

    .card__body.payment__container(:class="expandContent")

      template(v-if="plan.isMonthlyAndAnnualPlan")
        cp-types-plans(:plans="plan.plans")
        h3.titleStep__title Escolha o método de pagamento

      cp-payment-options(
        class="payment__payment-options z-901"
        v-if="payment.methodsOptions.length > 1"
        :methodsOptions="payment.methodsOptions"
        @selectedOption="changePayment"
      )

      .payment__wrapper
        .payment__methods
          .paymentMethod__card(v-if="/CREDIT_CARD|ALELO|VIRTUAL_DEBIT_CAIXA/.test(paymentMethod)")

            cp-card-info(
              v-if="paymentMethod === 'VIRTUAL_DEBIT_CAIXA'"
              iconName="warning--blue"
              text="<strong>Gere seu cartão de débito virtual Caixa Elo pelo App da Caixa ou Caixa Tem</strong>"
            )

            .payment__row
              cp-field.payment__row__numberCard(
                label="Número do cartão"
                for="numberCard"
                id="numberCard"
                placeholder="Somente números"
                type="tel"
                name="numberCard"
                autocomplete="cc-number"
                :mask="maskCard"
                :value="numberCard"
                :validation="numberCardValidation"
                :campaignSetup="payment.campaign"
                @change="setNumberCard"
              )
                i.iconBrand(:class="[brandClass, {'iconBrand--loading': payment.asyncPending}]")

              cp-field.payment__row__validateCard(
                label="Validade"
                placeholder="MM/AA"
                for="validateCard"
                id="validateCard"
                type="tel"
                name="validateCard"
                autocomplete="cc-exp"
                :mask="['##/##']"
                :value="validateCard"
                :validation="validateCardValidation"
                :maxlength="5"
                @change="setValidateCard"
              )

              cp-field.payment__row__cvvCard(
                label="CVV"
                for="securityCode"
                id="securityCode"
                type="tel"
                name="securityCode"
                autocomplete="cc-csc"
                :placeholder="lblPlaceholderCvv"
                :mask="maskCVV"
                :value="securityCode"
                :validation="securityCodeValidation"
                @change="setSecurityCode"
              )

            .payment__row
              cp-field.payment__row__nameCard(
                label="Nome do titular"
                for="nameCard"
                id="nameCard"
                type="text"
                name="nameCard"
                placeholder="Ex. Fulano da Silva"
                autocomplete="cc-name"
                :className="nameCard && 'uppercase'"
                :value="nameCard"
                :validation="nameCardValidation"
                :maxlength="25"
                @change="setNameCard"
              )

              cp-field.payment__row__cpfCard(
                label="CPF do titular"
                for="cpfCard"
                id="cpfCard"
                placeholder="Somente números"
                type="tel"
                name="cpfCard"
                :mask="['###.###.###-##']"
                :value="cpfCard"
                :validation="cpfCardValidation"
                @change="setCpfCard"
              )

            .payment__row(v-if="!isRecurrent")
              cp-field.payment__row__parcels(
                isSelect
                label="Número de parcelas"
                id="installments"
                :options="payment.installments[paymentMethod]"
                :validation="parcelsValidation"
                :value="parcels"
                @change="setParcels"
              )

          cp-scheduled-debt(
            v-if="paymentMethod === 'SCHEDULED_DEBIT'"
            :personalData="personalData"
            @outinput="getPaymentData"
          )

          cp-bank-slip(
            v-if="paymentMethod === 'BANK_SLIP'"
            :personalData="personalData"
            @outinput="getPaymentData"
          )

          cp-pix(
            v-if="paymentMethod === 'PIX'"
            @outinput="getPaymentData"
          )

          cp-mercado-pago(
            v-if="paymentMethod === 'MERCADO_PAGO'"
            @outinput="getPaymentData"
          )

          cp-voucher(
            v-if="paymentMethod === 'VOUCHER'"
            :holderCPF="personalData.cpf"
            @outinput="getPaymentData"
          )

        template(v-if="hasMobile && enablePromoCode")
          cp-warningBox(v-if="product.warningBox.enable" :config="product.warningBox")

        template(v-if="showBtnPayment")
          cp-alert(
            v-if="product.alert"
            :type="product.alert.type"
            :text="product.alert.text"
          )

          cp-terms-accept(v-if="!hasLead" @acceptedTerms="getAcceptedTerms")
          cp-modal-base(
            id="expired-promocode-modal"
            v-if="showExpiredPromoCodeModal"
            position="right"
          )
            cp-expired-promo-code-modal-content(
              @onQuoteAgain="quoteAgain"
            )
          .personal-data__row
            cp-button.btn__completePayment(
              size="medium"
              :label="lblBtnPayment"
              :disabled="isbtnDisabled"
              @onClick="requestPlanCreation"
            )
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import views from '@/mixins/views'
import moment from 'moment'
import dataLayer from '@/utils/data-layer'
import { CPF } from 'cpf_cnpj'
import { helpers, minLength, maxLength, required, requiredUnless } from 'vuelidate/lib/validators'
import { PROGRESS_STATE, FINISHED_STATE } from '@/stateSteps'
import { promoCodeReturnData } from '@/utils/promoCode'

import cpCardInfo from '@/components/molecules/CardInfo.vue'
import cpAlert from '@/components/atoms/Alert.vue'
import cpButton from '@/components/atoms/Button.vue'
import cpField from '@/components/molecules/Field.vue'
import cpIcon from '@/components/atoms/Icon.vue'
import cpLoader from '@/components/molecules/Loader.vue'
import cpTypesPlans from '@/components/molecules/TypesPlans'
import cpPaymentOptions from '@/components/atoms/PaymentOptions.vue'
import cpWarningBox from '@/components/atoms/WarningBox.vue'
import cpScheduledDebt from '@/components/molecules/paymentMethods/ScheduledDebt.vue'
import cpBankSlip from '@/components/molecules/paymentMethods/BankSlip.vue'
import cpPix from '@/components/molecules/paymentMethods/Pix.vue'
import cpMercadoPago from '@/components/molecules/paymentMethods/MercadoPago.vue'
import cpVoucher from '@/components/molecules/paymentMethods/Voucher.vue'
import cpTermsAccept from '@/components/atoms/TermsAccept.vue'
import cpModalBase from '@/components/organisms/ModalBase'
import cpExpiredPromoCodeModalContent from '@/components/molecules/ExpiredPromoCodeModalContent'

export default {
  name: 'Payment',
  mixins: [views],
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      isValidPaymentData: false,
      paymentMethodData: {},
      hasMobile: '',
      errorMsg: '',
      msgPlanExist: 'This User already has an active plan.',
      listPaymentTypes: {
        ALELO: 'alelo multibeneficios',
        CREDIT_CARD: 'credito',
        SCHEDULED_DEBIT: 'debito agendado',
        BANK_SLIP: 'boleto',
        PIX: 'pix',
        VOUCHER: 'voucher',
        MERCADO_PAGO: 'mercado pago',
        VIRTUAL_DEBIT_CAIXA: 'Débito Virtual Caixa'
      },
      listOfAcceptedConditions: [],
      isAcceptedTerms: true,
      hasLead: false,
      showExpiredPromoCodeModal: false
    }
  },
  components: {
    cpCardInfo,
    cpAlert,
    cpButton,
    cpField,
    cpIcon,
    cpLoader,
    cpTypesPlans,
    cpPaymentOptions,
    cpWarningBox,
    cpScheduledDebt,
    cpBankSlip,
    cpPix,
    cpMercadoPago,
    cpVoucher,
    cpTermsAccept,
    cpModalBase,
    cpExpiredPromoCodeModalContent
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)

    if (this.product?.params?.app_nolead) {
      this.hasLead = true
      this.isAcceptedTerms = false
    }
  },
  mounted () {
    if (this.paymentMethodsOptions.length === 1) {
      this.changePayment(this.paymentMethodsOptions[0])
    }
  },
  watch: {
    numberCard (newValue, oldValue) {
      if (
        newValue.slice(0, 6) === oldValue.slice(0, 6) &&
        (this.payment.asyncPending || this.payment.brand)
      ) return

      this.payment.brand = ''

      newValue.toString().length >= 6 && this.getCardBrand()
    },
    errorMsg (newValue) {
      newValue && this.errorMsg && setTimeout(() => { this.errorMsg = '' }, 7000)
    }
  },
  computed: {
    ...mapState([
      'product',
      'steps',
      'validatedSteps',
      'personalData',
      'payment',
      'plan'
    ]),
    ...mapGetters('payment', ['isAnnual']),
    titleStep () {
      let title = 'Como você deseja pagar?'

      if (this.paymentMethodsOptions.length === 1) {
        switch (this.product.campaign || this.product.alias) {
          case 'elo':
            title = 'Insira os dados do cartão de crédito Elo'
            break

          case 'coban':
          case 'bbseguros':
          case 'bolsa-protegida':
            title = 'Insira os dados do cartão de crédito'
            break

          default:
            title = 'Pagamento'
            break
        }
      } else if (this.plan.isMonthlyAndAnnualPlan) {
        title = 'Escolha o plano de pagamento'
      }

      return this.isProgressState ? title : 'Pagamento'
    },
    isRecurrent () {
      return this.product.recurrent === true
    },
    expandContent () {
      return {
        'payment__container--expand': this.steps.payment === PROGRESS_STATE || this.hasMobile
      }
    },
    isProgressState () {
      return this.steps.payment === PROGRESS_STATE || this.hasMobile
    },
    isFinishedState () {
      return this.steps.payment === FINISHED_STATE
    },
    paymentMethodsOptions () {
      return this.payment.methodsOptions
    },
    paymentMethod () {
      return this.payment.typePayment.method
    },
    numberCard () {
      return this.payment.numberCard
    },
    nameCard () {
      return this.payment.nameCard
    },
    securityCode () {
      return this.payment.securityCode
    },
    validateCard () {
      return this.payment.validateCard
    },
    cpfCard () {
      return this.payment.cpfCard
    },
    parcels () {
      return this.payment.parcels
    },
    lastcardNumbers () {
      return this.payment.lastCardNumbers
    },
    cardBrand () {
      return this.payment.brand
    },
    brandClass () {
      if (this.payment.brand && this.payment.brand !== '') {
        return [
          'amex',
          'aura',
          'diners',
          'discover',
          'elo',
          'hiper',
          'hipercard',
          'jcb',
          'master',
          'sorocred',
          'visa'
        ].find(brand => brand === this.payment.brand.toLowerCase()) || 'placeholder'
      }
      return false
    },
    maskCard () {
      return /amex|diners/i.test(this.payment.brand)
        ? ['#### ###### #####']
        : ['#### #### #### ####']
    },
    lblPlaceholderCvv () {
      const lblNumber = /amex/i.test(this.payment.brand) ? '4' : '3'
      return this.payment.brand
        ? `${lblNumber} dígitos`
        : 'Até 4 dígitos'
    },
    maskCVV () {
      return /amex/i.test(this.payment.brand) ? '####' : '###'
    },
    numberCardValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Cartão de crédito inválido ou bandeira não suportada',
          valid: false
        },
        {
          type: 'error',
          msg: 'Informe a numeração do seu cartão',
          valid: false
        },
        {
          msg: 'Verificando cartão...'
        }
      ]

      if (!this.payment.asyncPending) {
        if (!this.$v.numberCard.$invalid && this.numberCard.length >= 14) { return { valid: true } }
        if (this.$v.numberCard.$invalid && this.$v.numberCard.$dirty) {
          if (this.numberCard.length === 0) { return validations[1] }
          if (this.numberCard.length > 0) { return validations[0] }
        }
      } else {
        return validations[2]
      }

      return {}
    },
    nameCardValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, informe nome como está no cartão',
          valid: false
        }
      ]

      if (!this.$v.nameCard.$invalid) return { valid: true }
      if (this.$v.nameCard.$dirty && this.$v.nameCard.$invalid) return validations[0]

      return {}
    },
    securityCodeValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Código inválido',
          valid: false
        }
      ]

      if (!this.$v.securityCode.$invalid && this.securityCode.length >= 3) { return { valid: true } }
      if (this.$v.securityCode.$dirty && this.$v.securityCode.$invalid) { return validations[0] }

      return {}
    },
    validateCardValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Data inválida',
          valid: false
        },
        {
          type: 'error',
          msg: 'Cartão vencido',
          valid: false
        }
      ]

      if (!this.$v.validateCard.$invalid) { return { valid: true } }
      if (this.$v.validateCard.$dirty && this.$v.validateCard.$invalid) {
        if (this.validateCard.length < 4) { return validations[0] }
        if (!this.$v.validateCard.minValue) { return validations[1] }
      }

      return {}
    },
    cpfCardValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, insira um CPF',
          valid: false
        },
        {
          type: 'error',
          msg: 'CPF Inválido',
          valid: false
        },
        {
          msg: 'Verificando CPF...'
        }
      ]

      if (!this.$v.cpfCard.$invalid && this.cpfCard.length === 11) return { valid: true }
      if (this.$v.cpfCard.$dirty && this.$v.cpfCard.$invalid) {
        if (!this.$v.cpfCard.required) return validations[0]
        if (!this.$v.cpfCard.cpfValidator && this.$v.cpfCard.required) return validations[1]
        if (this.$v.cpfCard.cpfValidator && this.$v.cpfCard.$pending) return validations[3]
      }

      return {}
    },
    parcelsValidation () {
      if (!this.$v.parcels.$invalid && this.parcels) return { valid: true }

      return {}
    },
    showBtnPayment () {
      return /ALELO|CREDIT_CARD|SCHEDULED_DEBIT|BANK_SLIP|PIX|VOUCHER|MERCADO_PAGO|VIRTUAL_DEBIT_CAIXA/.test(this.paymentMethod)
    },
    lblBtnPayment () {
      const lblList = {
        BANK_SLIP: 'Confirmar compra',
        PIX: 'Gerar código Pix',
        MERCADO_PAGO: 'Pagar com Mercado Pago'
      }

      return lblList[this.paymentMethod] || 'Concluir pagamento'
    },
    isbtnDisabled () {
      const isSteps = !(this.validatedSteps.personalData && this.validatedSteps.address)

      const isPaymentCard = /ALELO|CREDIT_CARD|VIRTUAL_DEBIT_CAIXA/.test(this.paymentMethod) && this.$v.$invalid
      const isPaymentData = /SCHEDULED_DEBIT|BANK_SLIP|PIX|VOUCHER|MERCADO_PAGO/.test(this.paymentMethod) && !this.isValidPaymentData

      return isSteps || isPaymentCard || isPaymentData || this.isAcceptedTerms
    },
    enablePromoCode () {
      return this.plan.promoCode &&
        this.plan.promoCode.enable &&
        !this.isAnnual &&
        this.paymentMethod !== 'VOUCHER'
    }
  },
  methods: {
    ...mapActions('lead', ['patchLeadAction']),
    ...mapMutations('payment', [
      'changeTypePayment',
      'changeNumberCard',
      'changeNameCard',
      'changeValidateCard',
      'changeSecurityCode',
      'changeCpfCard',
      'changeAcceptedConditions',
      'changeActiveVoucher',
      'changePaymentMethodData'
    ]),
    ...mapActions('payment', [
      'changeParcels',
      'cleanCampaign',
      'createPlan',
      'getCardBrand',
      'getInstallments',
      'getTokenReCAPTCHA'
    ]),
    getPaymentData (value) {
      this.isValidPaymentData = value.isValid
      this.paymentMethodData = value.data

      this.changeParcels(value.installment)

      if (this.paymentMethod === 'VOUCHER') {
        this.changeActiveVoucher(value.isValid)
      }
    },
    setNumberCard (value) {
      this.setDirty(this.$v.numberCard)
      this.changeNumberCard(value)
    },
    setNameCard (value) {
      this.setDirty(this.$v.nameCard)
      this.changeNameCard(value)
    },
    setSecurityCode (value) {
      this.setDirty(this.$v.securityCode)
      this.changeSecurityCode(value)
    },
    setValidateCard (value) {
      this.setDirty(this.$v.validateCard)
      this.changeValidateCard(value)
    },
    setCpfCard (value) {
      this.setDirty(this.$v.cpfCard)
      this.changeCpfCard(value)
    },
    setParcels (value) {
      this.setDirty(this.$v.parcels)
      this.changeParcels(value)
    },
    changePayment (payment) {
      this.changeTypePayment(payment)
      this.setDataLayer('paymentMethod')
      this.changeActiveVoucher(false)

      if (!this.isRecurrent && /ALELO|CREDIT_CARD|VIRTUAL_DEBIT_CAIXA/i.test(payment.method)) {
        this.getInstallments()
      }

      if (/ALELO/i.test(payment.method)) {
        this.setParcels(1)
      }
    },
    getAcceptedTerms (value) {
      this.isAcceptedTerms = value
    },
    async requestPlanCreation () {
      if (!navigator.onLine) {
        this.errorMsg = 'Você está off-line. Verifique sua conexão.'
        return false
      }

      if (this.isExpiredPromoCode()) {
        this.showExpiredPromoCodeModal = true
        return
      }

      try {
        this.isLoading = true
        this.setDataLayer('attempted')
        this.changePaymentMethodData(this.paymentMethodData)
        this.changeAcceptedConditions(this.listOfAcceptedConditions)

        await this.getTokenReCAPTCHA()

        const { data } = await this.createPlan()

        this.planSuccessfullyCreated(data)
      } catch (error) {
        this.$sentry.logWithContext({
          level: 'error',
          tags: {
            app_product: this.product.alias,
            app_step: 'pagamento',
            app_errorZone: 'requestPlanCreation'
          },
          ctx: {
            label: '[PAYMENT] - requestPlanCreation'
          },
          error
        })

        const apiErrorMessage =
          error.response?.data?.message ||
          (error.response?.data?.errorDetails && error.response?.data?.errorDetails[0]?.message)

        if (apiErrorMessage) {
          this.setDataLayer('inputError')

          if (apiErrorMessage === this.msgPlanExist) {
            window.location.replace(`${this.product.redirectError}`)
            return false
          }

          this.errorMsg = apiErrorMessage
        } else {
          this.setDataLayer('systemError')
          this.errorMsg = 'Não foi possível processar o seu pagamento. Confira os dados e tente novamente mais tarde.'
        }

        this.isLoading = false
      }
    },
    async planSuccessfullyCreated (data) {
      try {
        if (data.uuid) {
          this.setDataLayer('success')

          this.updateProductSession(data)

          const dl = {
            event: `ecommerce-${this.product.alias}`,
            parcelas: this.parcels,
            meiopagamento: this.paymentMethod,
            cupom: this.plan.promoCode.code,
            sku: this.plan.uuid,
            name: `${this.plan.category} - ${this.plan.planType}`,
            category: 'Saúde Protegida',
            price: this.plan.value,
            quantity: 1,
            transactionId: data.uuid,
            transactionAffiliation: 'semprebem',
            transactionTotal: this.plan.precoTotal,
            transactionTax: '0',
            transactionShipping: '0'
          }

          window.dataLayer.push(dl)

          // when product enable promo code to be applied when in checkout,
          // return applied promo code to caller
          promoCodeReturnData()

          await this.patchLeadAction({
            leadAdditionalInformation: {
              paymentType: this.paymentMethod
            }
          })

          this.nextStep()
        }
      } catch (error) {
        this.$sentry.logWithContext({
          level: 'error',
          tags: {
            app_product: this.product.alias,
            app_step: 'pagamento',
            app_errorZone: 'planSuccessfullyCreated'
          },
          ctx: {
            label: '[PAYMENT] - planSuccessfullyCreated'
          },
          error
        })

        this.setDataLayer('systemError')
        this.errorMsg = 'Não foi possível processar o seu pagamento. Confira os dados e tente novamente mais tarde.'

        this.isLoading = false
      }
    },
    updateProductSession (data) {
      const email = data.email || (data.payment && data.payment.email) || null

      const sessionData = {
        ...(data.policyNumber && { policyNumber: data.policyNumber }),
        ...(email && { email }),
        ...(Object.prototype.hasOwnProperty.call(this.payment.typePayment, 'isInstant') && { isInstant: this.payment.typePayment.isInstant }),
        ...(this.parcels && {
          installment: this.parcels,
          installmentValues: this.plan.parcelasPrecos
        }),
        ...(this.product.isRenovation && { isRenovation: this.product.isRenovation }),
        typePayment: this.paymentMethod,
        amount: this.isAnnual ? this.plan.annualValue : this.plan.precoTotal,
        planUuid: data.uuid
      }

      if (/ALELO|CREDIT_CARD|VIRTUAL_DEBIT_CAIXA/.test(this.paymentMethod)) {
        sessionData.payment = {
          ...sessionData.payment,
          cardBrand: this.cardBrand,
          lastcardNumbers: this.lastcardNumbers
        }
      } else if (this.paymentMethod === 'SCHEDULED_DEBIT') {
        sessionData.payment = {
          ...sessionData.payment,
          lastDigitsAgency: this.paymentMethodData.agency.slice(-2),
          lastDigitsAccount: this.paymentMethodData.account.slice(-3)
        }
      } else if (this.paymentMethod === 'BANK_SLIP') {
        sessionData.payment = {
          ...sessionData.payment,
          digitableLine: data.payment.digitableLine,
          url: data.payment.url
        }
      } else if (/PIX|VOUCHER/.test(this.paymentMethod)) {
        sessionData.payment = {
          ...sessionData.payment,
          ...data.payment
        }
      }

      window.sessionStorage.setItem(
        'semprebem:payment', JSON.stringify(sessionData)
      )
    },
    nextStep () {
      // Adicionando um delay para métrica de e-commerce contabilizar no GTM
      setTimeout(() => {
        this.$router.push({ name: 'success' })
      }, 1000)
    },
    openStep () {
      this.steps.personalData = FINISHED_STATE
      this.steps.address = FINISHED_STATE
      this.steps.payment = PROGRESS_STATE

      this.$router.push({ name: 'payment' })
    },
    handleResize () {
      this.hasMobile = window.innerWidth <= 767
    },
    setDataLayer (type) {
      const lblRenovation = this.product.isRenovation ? '-renovacao' : ''
      const metricsList = {
        paymentMethod: {
          event: `${this.product.alias}-semprebem`,
          category: `${this.product.alias}-pagamento`,
          action: 'método-pagamento',
          label: this.listPaymentTypes[this.paymentMethod]
        },
        attempted: {
          event: `${this.product.alias}-semprebem`,
          category: `${this.product.alias}-pagamento${lblRenovation}`,
          action: 'click',
          label: 'tentativa'
        },
        success: {
          event: `${this.product.alias}-semprebem`,
          category: `${this.product.alias}-pagamento`,
          action: 'click',
          label: 'proteger-agora'
        },
        systemError: {
          event: `${this.product.alias}-semprebem`,
          category: `error-pagamento${lblRenovation}`,
          action: 'erro',
          label: 'erro do sistema'
        },
        inputError: {
          event: `${this.product.alias}-semprebem`,
          category: `error-pagamento${lblRenovation}`,
          action: 'click',
          label: 'erro de input'
        }
      }

      dataLayer(metricsList[type])
    },
    isExpiredPromoCode () {
      const promoCodeExpirationLessThreeHours = new Date(this.product.promoCodeExpiration)
        .setHours(
          new Date(this.product.promoCodeExpiration)
            .getHours() - 3 // server is 3 hours ahead
        )
      return promoCodeExpirationLessThreeHours < Date.parse(new Date())
    },
    quoteAgain () {
      this.showExpiredPromoCodeModal = false
      window.sessionStorage.removeItem('semprebem:checkout')
      window.sessionStorage.removeItem('semprebem:product')
      window.open(this.product.quotationUrl, '_self')
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  validations: {
    numberCard: {
      required,
      minLength: minLength(14),
      maxLength: maxLength(16),
      isBrand () { return this.payment.brand }
    },
    nameCard: {
      required,
      maxLength: maxLength(25),
      alphaWhiteDiacritic: helpers.regex('alphaWhiteDiacritic', /^[a-zA-Z.\s]*$/),
      fullName: helpers.regex('fullName', /.{1,}\s.{1,}/),
      blackListName: (value) => !(/((^|\s)((teste|test)(s)?)(\s|$))/i.test(value))
    },
    securityCode: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(4)
    },
    validateCard: {
      required,
      date: helpers.regex('date', /(0[1-9]|10|11|12)[0-9]{2}/),
      minValue: (value) => moment(value, 'MMYY').endOf('month') > moment.now()
    },
    cpfCard: {
      required,
      cpfValidator: (value) => CPF.isValid(value)
    },
    parcels: {
      required: requiredUnless('isRecurrent')
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .payment {
    &__container {
      display: none;

      &--expand {
        display: block;
      }
    }

    &__payment-options {
      margin-top: 32px;
    }

    &__row {
      position: relative;
      width: 100%;

      @media screen and (min-width: 768px) {
        display: flex;
        justify-content: flex-start;
      }

      &__validateCard,
      &__cvvCard {
        @media screen and (min-width: 768px) {
          max-width: 157px;
        }
      }

      &__cpfCard {
        @media screen and (min-width: 768px) {
          max-width: 330px;
        }
      }
    }

    &__wrapper {
      position: relative;
    }

    &__methods ~ * {
      margin-top: 48px;
    }

    .alert + * {
      margin-top: 16px;
    }

    .promoCode + * {
      margin-top: 60px;
    }

    .confirmTerms {
      border-top: 1px solid rgba(189, 194, 198, 0.3);
    }
  }

  .infoPayment {
    color: #595959;
    font-family: $rubik-font-family;
    font-size: 14px;
    font-weight: normal;
    margin-top: 28px;
  }

  .iconBrand {
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    border: none;
    height: 22px;
    position: absolute;
    right: 18px;
    top: 40px;
    width: 32px;

    $brands: (amex, aura, diners, discover, elo, hiper, hipercard, jcb, master, placeholder, visa);

    @each $brand in $brands {
      &.#{$brand} {
        background-image: url("~@/assets/flags/#{$brand}.png");
      }
    }

    &.sorocred {
      background-image: url("~@/assets/flags/sorocred.svg");
    }

    &--loading {
      animation: rotation 1s linear infinite;
      border: 2px solid #1A71B4;
      border-bottom-color: transparent;
      border-radius: 50%;
      box-sizing: border-box;
      display: inline-block;
      height: 20px;
      width: 20px;

      @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
      }
    }
  }

  .msg-error {
    background-color: rgba(255, 59, 48, 1);
    display: flex;
    height: auto;
    justify-content: center;
    left: 0;
    top: 0;
    padding: 16px;
    position: fixed;
    width: 100%;

    &__icon {
      margin-right: 16px;
      width: 20px;
    }

    span {
      font-weight: 500;
      font-size: 16px;
      font-family: $rubik-font-family;
      color: #fff;

      @media screen and (max-width: 767px) {
        font-size: 14px;
      }
    }

    @at-root {
      .header ~ .hiring-step .msg-error {
        top: 76px;

        @media screen and (max-width: 767px) {
          top: 56px;
        }
      }
    }
  }

  .loader-content {
    align-items: center;
    background-color: rgba(#fff, .95);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;

    &__payment {
      position: fixed;
    }
  }
</style>
